import React, { useMemo } from "react";
import { TextField } from "@mui/material";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import ruLocale from "date-fns/locale/ru";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePicker } from "@mui/lab";

const formatToDdMmYyyy = (raw) => {
  const digits = String(raw || "").replace(/\D/g, "").slice(0, 8);
  if (!digits) return "";
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
};

export const CustomDatePicker = ({
  value,
  maxValue,
  onChange,
  label,
  fullWidth,
  required,
  disabled,
  autoFormatDDMMYYYY,
}) => {
  return useMemo(() => {
    return (
      <LocalizationProvider locale={ruLocale} dateAdapter={AdapterDateFns}>
        <DatePicker
          views={["day"]}
          label={label}
          value={value}
          onChange={onChange}
          maxDate={maxValue}
          disabled={disabled}
          required={required}
          renderInput={(params) => (
            <TextField
              margin="normal"
              disabled={disabled}
              fullWidth={fullWidth}
              inputProps={{
                ...params.inputProps,
                inputMode: autoFormatDDMMYYYY ? "numeric" : params.inputProps?.inputMode,
              }}
              onChange={(e) => {
                if (!autoFormatDDMMYYYY) {
                  params?.inputProps?.onChange?.(e);
                  return;
                }
                const next = formatToDdMmYyyy(e?.target?.value);
                // mutate value so MUI DatePicker internal parser gets formatted string
                if (e?.target) e.target.value = next;
                if (e?.currentTarget) e.currentTarget.value = next;
                params?.inputProps?.onChange?.(e);
              }}
              {...params}
            />
          )}
        />
      </LocalizationProvider>
    );
  }, [label, value, maxValue, onChange, fullWidth, required, disabled, autoFormatDDMMYYYY]);
};

CustomDatePicker.defaultProps = {
  required: true,
  disabled: false,
  fullWidth: true,
  autoFormatDDMMYYYY: false,
};
